
import React, { useCallback, useEffect, useState } from 'react';
import { IView } from 'Framework';
import { IconMore } from 'src/content/icons';
import { strings } from 'src/localization';
import css from './UpcomingApptCard.module.scss';
import AppointmentCard from 'src/components/AppointmentCard/AppointmentCard';
import SVPButton from '../SVPButtons/SVPButton';
import { ViewMode } from 'src/enums';
import { ComponentMapIds } from '../map';
import { VehicleRecs, UpdateApptDateInp, UpdateApptVehInp, ViewApptList, VehicleRec, VehData, DeteremineDeptInp, QuickTimeInp, ViewAppt, NextAppointmentOp, WebOp, UpdateApptOpsInp, OpType, ApptVeh, ascCtaInteractionInput } from 'src/models';
import { IServicesState, ISpecsState } from 'src/store/states';
import { LoadingProgress } from '@framework-controls/core';
import { ascCtaInteraction } from 'src/helpers/EventHelper/EventHelper';
import classNames from 'classnames';

export interface IProps {
    advImgAltTag?: string;
    advisorPhotoPath?: any;
    viewMode: ViewMode;
    // appointment: IAppointmentState;
    clearMainPanes: () => void;
    pushToMainPanes: (inputView: IView) => void;
    setViewMode: (viewMode: ViewMode) => void;
    apptVehicle: VehicleRecs;
    selectedVehicle?: string;
    apptList?: ViewApptList;
    theme: string;
    additionalServices: IServicesState;
    specData?: ISpecsState;
    specDefaultDept: string;
    profile: string;
    store: string;
    branch: string;
    apptVin: string;
    menusReturnCode: string;
    waitOnRecall: boolean;
    individualServices: WebOp[];
    updateApptDate: (apptDate: UpdateApptDateInp) => void;
    updateApptOps: (inputOps: UpdateApptOpsInp[]) => void;
    updateApptVehicle: (apptVehicle: UpdateApptVehInp) => void;
    getAdditionalServices: (profileNum: string, store: string, branch: string) => void;
    getApptOps: (profileNum: string, store: string, branch: string, vehData?: VehData) => void;
    clearAdditionalServices: () => void;
    determineDept: (inp: DeteremineDeptInp) => void;
    getMenus: (value1, value2) => void;
    getQuickTimes: (inp: QuickTimeInp) => void;
    getDeptSpecs: () => void;
    clearMenusState: () => void;
    locale: string;
    getMaintContracts: () => void;
    MCReturned: boolean;
    MCError: boolean;
    setWaitOnMC: (value: boolean) => void;
    waitOnMC: boolean;
    toyotaMCLaunched: string;
    lexusMCLaunched: string;
    apptVeh: ApptVeh;
    updateVehicleMileage: (mileage: number) => void,
    TMNAMileage: number;
    countryCode: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
}

const UpcomingApptCard = (props: IProps) => {
    const [expand, setExpand] = useState(false);
    const [gettingData, setGettingData] = useState<boolean>(false);
    const [clearingData, setClearingData] = useState<boolean>(false);
    const noArrow = props.theme === 'porsche' || props.theme === 'bmw' ? true : false;

    let box1ClassName = css.box1;
    let box2ClassName = css.box2;
    let literalClassName = css.literal;
    if (props.theme === 'colorSensitive') {
        box1ClassName = css.box1ADA;
        box2ClassName = css.box2ADA;
        literalClassName = css.literalADA;
    }

    const litStyles = classNames(
        css.lit2,
        {
            [css.lit2Mazda]: props.theme === 'mazda',
        },
    );

    let apptList: ViewAppt | undefined = undefined;
    let apptVehicle: VehicleRec | undefined = undefined;
    if (props.selectedVehicle) {
        apptVehicle = Object.values(props.apptVehicle).find(veh => veh.id === props.selectedVehicle);
        if (apptVehicle && props.apptList) {
            apptList = Object.values(props.apptList).find((appt) => appt.apptNum === apptVehicle?.nextAppt);
        }
    }
    const appointment = apptList;

    // Format apptList data
    // if (apptList) {
    //     const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
    //         'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',
    //     ];

    //     const date = new Date(apptList.date);
    // const month = monthNames[date.getMonth()];
    // const formattedDate = date.getDate() + ' ' + month + ' ' + date.getFullYear();
    // const hour = apptList.time.substring(0, 2);
    // if (apptList.time.substring(5) === 'pm') {
    //     hour = (parseInt(hour) + 12).toString();
    // }
    // const time = hour + apptList.time.substring(2, 5);
    // apptList = { ...apptList, date: formattedDate, time: time };
    // }

    useEffect(() => {
        // We need to update the appointment vehicle in order for the getAdditionalServices call to be accurate
        // if we did not go through VehSel
        if (props.selectedVehicle) {
            const apptVehicle = props.apptVehicle.find(veh => veh.id === props.selectedVehicle);
            if (apptVehicle && apptList) {
                const vehicle: UpdateApptVehInp = {
                    vin: apptVehicle.vin,
                    makeCode: apptVehicle.makeCode,
                    make: apptVehicle.make,
                    model: apptVehicle.model,
                    series: apptVehicle.style,
                    vehYr: apptVehicle.year,
                    vehColor: apptVehicle.color,
                    mileage: apptList.mileage,
                    imagePath: apptVehicle.imagePath,
                };
                props.updateApptVehicle(vehicle);
            }
        }
    }, [apptList, props.apptVehicle, props.selectedVehicle, props.apptVin,
        props.updateApptVehicle]);

    useEffect(() => {
        if (appointment) {
            const determineDept = {
                defaultDept: appointment.department,
            };
            if (determineDept) {
                props.determineDept(determineDept);
                props.getDeptSpecs();
            }
        }
        // if (!props.specData?.deptSpecs && props.viewMode === ViewMode.EditAppt) {
        //     props.getDeptSpecs();
        // }
    }, [props.specData?.deptSpecs, props.viewMode, props.getDeptSpecs, appointment, props.determineDept]);

    useEffect(() => {
        if (!clearingData && apptVehicle && apptList) {
            const defaultDept = props.specDefaultDept;
            const determineDept = {
                defaultDept: defaultDept,
            };
            props.determineDept(determineDept);
            props.clearAdditionalServices();
            props.clearMenusState();
            setClearingData(true);
        }
    }, [props.specDefaultDept, apptList, apptVehicle, clearingData, props.clearAdditionalServices,
        props.determineDept, props.clearMenusState]);

    useEffect(() => {
        if (clearingData && !gettingData && apptVehicle && apptList &&
            !props.additionalServices.allServices.built && props.menusReturnCode === '') {
            setGettingData(true);
            props.getApptOps(props.profile, props.store, props.branch);
            const scheduleOption = apptList.scheduleOption;
            const mileageMenu = apptList.mileageMenu;
            props.getMenus(scheduleOption, mileageMenu);
            // Need to update the ApptOps state with the operations from the appointment
            // This is for using operations in the QuickTimes call
            if (apptList) {
                const apptOps: UpdateApptOpsInp[] = [];
                apptList.ApptOps.forEach((service, index) => {
                    apptOps.push({
                        id: (index).toString(),
                        operation: service.opCode,
                        concern: service.opDesc,
                        estTime: '',
                        menuID: '',
                        spgOp: '',
                        opType: OpType.ViewApptListService,
                        department: '',
                        itemCostLow: service.opQuote ? service.opQuote : '',
                        itemCostHigh: service.opQuote ? service.opQuote : '',
                        opWaiter: '',
                        opLoaner: '',
                        opRental: '',
                        opConcierge: '',
                        opCadillac: '',
                        opPPUDWL: '',
                    });
                });
                props.updateApptOps(apptOps);
            }
            // Need to determine whether any of the operations in ApptOps are recalls
            const selectedRecalls =
                apptList?.ApptOps.filter((apptOp) => apptOp?.opDesc?.indexOf(strings.RecallOp) !== -1);

            // If a recall was found, assign a value of true to recallSelected.
            let recallSelected = false;
            if (selectedRecalls.length > 0) {
                recallSelected = true;
            }
            const quickTimesInp = {
                specProfile: props.profile,
                department: apptList.department,
                lastAdv: apptList.advisor,
                lastTrans: apptVehicle.lastTrans,
                recallSelected: recallSelected,
            };
            props.getQuickTimes(quickTimesInp);
            props.getAdditionalServices(props.profile, props.store, props.branch);
        }
    }, [apptList, props.profile, props.store, props.branch, apptVehicle, clearingData, props.menusReturnCode,
        gettingData, props.additionalServices.allServices.built, props.getAdditionalServices, props.getApptOps,
        props.getMenus, props.getQuickTimes, props.updateApptOps]);

    useEffect(() => {
        if (gettingData && props.additionalServices.allServices.built && props.menusReturnCode !== '' && apptList) {
            setGettingData(false);
        }
    }, [props.menusReturnCode, gettingData, props.additionalServices.allServices.built, apptList]);

    // Change to use Adv First Last name form Appt state
    const AdvImgAltTag = 'AdvFirst AdvLast ' + strings.Photo;

    let advisorImg = '';
    let services: NextAppointmentOp[] = [];
    if (apptList && apptList.apptNum !== '') {
        advisorImg = apptList.advImage;
        services = [];
        apptList.ApptOps.forEach(s => {
            const individualIndex = props.individualServices.findIndex((indiv) => indiv.id === s.opCode);

            if (individualIndex !== -1) {
                services.push({
                    opCode: props.individualServices[individualIndex].id,
                    opDesc: props.individualServices[individualIndex].webTitle,
                    opQuote: s.opQuote,
                });
            } else {
                services.push(s);
            }
        });
    }

    let apptDateObject = new Date();
    if (apptList) {
        const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
            'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC',
        ];

        const date = new Date(apptList.date);
        const month = monthNames[date.getMonth()];
        const formattedDate = date.getDate() + ' ' + month + ' ' + date.getFullYear();
        let hour = apptList.time.substring(0, 2);
        if (apptList.time.substring(5) === 'pm') {
            if (hour !== '12') {
                hour = (parseInt(hour) + 12).toString();
            }
        }
        const time = hour + apptList.time.substring(2, 5);
        apptDateObject = new Date(`${formattedDate} ${time}`);
    }

    let apptMsgType = true;
    const currentDate = new Date();
    const timeDifference = apptDateObject.getTime() - currentDate.getTime();
    if (timeDifference < 0) {
        apptMsgType = false;
    }
    const daysDiff = timeDifference / (1000 * 60 * 60 * 24);
    const daysDiffFloor = Math.floor(daysDiff);
    const hoursDiff = (daysDiff - daysDiffFloor) * 24;
    const hoursDiffFloor = Math.floor(hoursDiff);
    const minutesDiffFloor = Math.floor((hoursDiff - hoursDiffFloor) * 60);
    const daysLit = daysDiffFloor > 1 ? strings.TimerDays : strings.TimerDay;
    const hoursLit = hoursDiffFloor > 1 ? strings.TimerHours : strings.TimerHour;
    const minutesLit = minutesDiffFloor > 1 ? strings.TimerMinutes : strings.TimerMinute;
    const apptTimerDays = daysDiffFloor !== 0 ? `${daysDiffFloor} ${daysLit}, ` : '';
    const apptTimerHours = hoursDiffFloor !== 0 ? `${hoursDiffFloor} ${hoursLit} ` : '';
    const apptTimerJoin = apptTimerDays || apptTimerHours ? `${strings.And} ` : '';
    const appointmentTimer = apptTimerDays + apptTimerHours + apptTimerJoin + `${minutesDiffFloor} ${minutesLit}`;

    const serviceLines = services.map(service => (
        <div key={services!.indexOf(service)} className={css.serviceRow}>
            <div className={css.svcRow}>
                <span className={css.numberCircle}>{services!.indexOf(service) + 1}</span>
                <span className={css.description}>{service.opDesc}</span>
            </div>
        </div>
    ));

    //  Switch to the Summary screen.
    const btnHandler = (e: any) => {
        if (apptList) {
            if (appointment) {
                const date: UpdateApptDateInp = {
                    selDate: appointment.date,
                    selTime: appointment.time,
                    selTrans: appointment.trans,
                    selAdv: appointment.advisor,
                    selAdvName: appointment.advName,
                    selAdvImage: appointment.advImage,
                    selTransFlag: appointment.transFlag,
                    selApptNum: appointment.apptNum,
                };
                props.updateApptDate(date);
                const determineDept = {
                    defaultDept: appointment.department,
                };
                props.determineDept(determineDept);
            }

            const maintMake = props.apptVeh.make.toLowerCase().split(' ')[0];
            const maintContractView = (props.apptVeh && props.countryCode === 'US' &&
            (((props.lexusMCLaunched || props.lexusTDMCLaunched) && maintMake === 'lexus') ||
            ((props.toyotaMCLaunched || props.toyotaTDMCLaunched) && maintMake === 'toyota')));

            if (maintContractView && !props.MCReturned && !props.MCError && !props.waitOnMC) {
                props.getMaintContracts();
                props.setWaitOnMC(true);
                props.setViewMode(ViewMode.EditAppt);
            } else {
                props.setViewMode(ViewMode.EditAppt);

                props.pushToMainPanes({
                    viewId: ComponentMapIds.Summary,
                    component: ComponentMapIds.Summary,
                });
            }
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.EditAppt,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.apptVehicle, props.selectedVehicle);
    };

    useEffect(() => {
        if (props.waitOnMC && (props.MCReturned || props.MCError)) {
            props.setWaitOnMC(false);
            if (props.viewMode === ViewMode.EditAppt) {
                if (props.apptVeh.mileage < props.TMNAMileage) {
                    props.updateVehicleMileage(props.TMNAMileage);
                }

                props.pushToMainPanes({
                    viewId: ComponentMapIds.Summary,
                    component: ComponentMapIds.Summary,
                });
            }
        }
    }, [props.MCReturned, props.MCError, props.setWaitOnMC, props.waitOnMC, props.TMNAMileage, props.updateVehicleMileage,
        props.apptVeh, props.setViewMode, props.pushToMainPanes, props.viewMode]);

    let buttonClass = css.moreDetailsBtn;
    if (expand) {
        buttonClass = css.lessDetailsBtn;
    }

    const moreClick = useCallback(() => {
        setExpand(expand => !expand);
    }, []);

    const summaryTitleClass = classNames(
        css.summaryTitle,
        {
            [css.summaryTitleBMW]: props.theme === 'bmw',
            [css.summaryTitleBuick]: props.theme === 'buick',
            [css.summaryTitleDodge]: props.theme === 'dodge',
            [css.summaryTitleFord]: props.theme === 'ford',
            [css.summaryTitleIN]: props.theme === 'infiniti',
            [css.summaryTitleMazda]: props.theme === 'mazda',
        },
    );

    const timeTillApptStyles = classNames(
        css.timeTillAppt,
        {
            [css.timeTillApptBMW]: props.theme === 'bmw',
            [css.timeTillApptFord]: props.theme === 'ford',
            [css.timeTillApptNissan]: props.theme === 'nissan',
            [css.timeTillApptIN]: props.theme === 'infiniti',
        },
    );

    // Get the Transportation state to display the transportation title on the appointment card.
    const transportation = appointment?.transFlag;
    const transIndex = props.specData?.deptSpecs?.Transportation.find(trans => trans.type === transportation);
    let apptIn = strings.Appointment + ' ' + strings.In + ': ';
    if (props.locale === 'fr-CA'){
        apptIn = strings.ApptIn;
    }

    return (
        <div>
            {gettingData && !props.waitOnRecall ? <LoadingProgress cssClasses={{ spinner: css.progressColor }} size={100} /> : null}
            {apptList && apptList.apptNum !== ''?
                <div id='upcomingAppt'>
                    <hr className={css.hr} />
                    <div>

                        <h4 className={summaryTitleClass}>{strings.UpcomingAppt}</h4>
                        <div className={box1ClassName}>
                            <div className={box2ClassName}>
                                <AppointmentCard
                                    // appointment={{...apptList, department: ''}}
                                    appointment={apptList}
                                    transIndex={transIndex}
                                    advisorPhotoPath={advisorImg}
                                    advImgAltTag={AdvImgAltTag}
                                    viewMode={ViewMode.CustAcct}
                                    theme={props.theme}
                                    locale={props.locale}
                                />
                                <div className={buttonClass}>
                                    <div>
                                        {apptMsgType ?
                                            <div>
                                                {apptIn}
                                                <span className={timeTillApptStyles}>{appointmentTimer}</span>
                                            </div>:
                                            <div>
                                                {strings.Appointment + ' ' + strings.Missed}
                                            </div>}
                                    </div>
                                </div>
                            </div>
                            <div className={css.svcLines + ' ' + buttonClass} >
                                <div className={timeTillApptStyles}>{strings.ServicesOn}:</div>
                                {serviceLines}
                            </div>
                            <div id='moreBtn' className={literalClassName} onClick={moreClick} title={strings.ClickHereMoreDtl}>
                                {(props.theme !== 'mazda' && props.theme !== 'acura') && <IconMore />}
                                <small className={litStyles} id='detailsBtnLbl'>
                                    {expand ? strings.LessDtls : strings.MoreDtls}
                                </small>
                            </div>
                        </div>
                        <div className={css.btnDiv}>
                            <div className={css.btnDiv2}>
                                <SVPButton
                                    id='EditApptBtn'
                                    variant={'secondaryBtnAlt'}
                                    message={strings.EditAppt}
                                    handler={btnHandler}
                                    isDisabled={false}
                                    tooltip={strings.ChangeApptTip}
                                    theme={props.theme}
                                    noArrow={noArrow}
                                />
                            </div>
                        </div>
                    </div>
                </div> :
                <div></div>
            }
        </div>
    );
};

export default UpcomingApptCard;